import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./dialog";
import { AppButton } from "./AppButton";
import { CSSProperties } from "@emotion/serialize";

interface AppDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  subtitle?: string;
  description?: string;
  children: React.ReactNode;
  onSubmit?: () => void;
  onCancel?: () => void;
  submitText?: string;
  cancelText?: string;
  loading?: boolean;
  disabled?: boolean;
  styles?: CSSProperties;
  divider?: boolean;
}

export function DocumentDialog({
  open,
  onOpenChange,
  title,
  subtitle,
  description,
  children,
  onSubmit,
  onCancel,
  submitText = "Create",
  cancelText = "Cancel",
  loading = false,
  disabled,
  styles,
  divider = true,
}: AppDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl bg-white p-8 !rounded-[30px] mt-6">
        {/* Dialog Header */}
        <DialogHeader className="flex flex-row items-center justify-between border-b border-gray-200 pb-4">
          <div>
            <DialogTitle className="text-lg font-semibold text-gray-900">
              {title}
            </DialogTitle>
            {subtitle && (
              <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
            )}
            {description && (
              <DialogDescription className="text-xs text-gray-400">
                {description}
              </DialogDescription>
            )}
          </div>

          {/* Header Actions */}
          <div className="flex gap-3">
            {onCancel && (
              <AppButton
                variant="outline"
                onClick={onCancel}
                className="px-6 py-2 text-gray-700 border border-gray-300 rounded-full hover:bg-gray-100"
              >
                {cancelText}
              </AppButton>
            )}
            {onSubmit && (
              <AppButton
                onClick={onSubmit}
                disabled={disabled}
                className="px-6 py-2 bg-[#08453E] text-white rounded-full hover:bg-gray-300 disabled:bg-[#DDDDDD] disabled:text-[#6F6F6F]"
              >
                {loading ? "Creating..." : submitText}
              </AppButton>
            )}
          </div>
        </DialogHeader>

        {/* Divider */}
        {divider && (
          <div
            className="border-t border-gray-200 my-4"
            style={{ marginLeft: 24, marginRight: 24 }}
          />
        )}

        {/* Divider */}
        {divider && (
          <div
            className="border-t border-gray-200 my-4"
            style={{ marginLeft: 24, marginRight: 24 }}
          />
        )}

        {/* Form Content */}
        <div className="px-6 pb-6">{children}</div>

        {/* </form> */}
      </DialogContent>
    </Dialog>
  );
}
